import config from "constants/config";
import PaylixecommerceDark from "../assets/images/loader_logo_dark.svg";
import PaylixEcommerceWhite from "../assets/images/loader_logo_light.svg";



export default ({ id, type, isDark }) => {

	if(id) {
		return `https://imagedelivery.net/${config.CLOUD_FIRE_ID}/${id}/${type ? type.toLowerCase() : 'default'}`
	} else {
		return isDark ? PaylixEcommerceWhite : PaylixecommerceDark;
	}

}